'use strict';

var cyrillicToRomanDictionary = [["А", "A"], ["а", "a"], ["Б", "B"], ["б", "b"], ["В", "V"], ["в", "v"], ["Г", "G"], ["г", "g"], ["Д", "D"], ["д", "d"], ["Е", "E"], ["е", "e"], ["Ё", "Yo"], ["ё", "yo"], ["Ж", "Zh"], ["ж", "zh"], ["З", "Z"], ["з", "z"], ["И", "I"], ["и", "i"], ["Й", "J"], ["й", "j"], ["К", "K"], ["к", "k"], ["Л", "L"], ["л", "l"], ["М", "M"], ["м", "m"], ["Н", "N"], ["н", "n"], ["О", "O"], ["о", "o"], ["П", "P"], ["п", "p"], ["Р", "R"], ["р", "r"], ["С", "S"], ["с", "s"], ["Т", "T"], ["т", "t"], ["У", "U"], ["у", "u"], ["Ф", "F"], ["ф", "f"], ["Х", "H"], ["х", "h"], ["Ц", "Ts"], ["ц", "ts"], ["Ч", "Ch"], ["ч", "ch"], ["Ш", "Sh"], ["ш", "sh"], ["Щ", "Sch"], ["щ", "sch"], ["Ъ", ""], ["ъ", ""], ["Ы", "Y"], ["ы", "y"], ["Ь", ""], ["ь", ""], ["Э", "E"], ["э", "e"], ["Ю", "Yu"], ["ю", "yu"], ["Я", "Ya"], ["я", "ya"]];

function convertCyrillicToRoman(name) {
  return Object.values(name).map(function (cyrillicCharacter) {
    var romanCharacter = cyrillicToRomanDictionary.find(function (translations) {
      return translations[0] === cyrillicCharacter;
    });
    return romanCharacter ? romanCharacter[1] : cyrillicCharacter;
  }).join("");
}

function removeDiacritics(name) {
  return Object.values(name.normalize("NFD")).map(function (normalisedCharacter) {
    if (normalisedCharacter.match(/[0-9A-Za-z \-/.]/g)) {
      return normalisedCharacter;
    }
  }).join("").normalize("NFC");
}

function sanitiseName(name) {
  return removeDiacritics(name.trim()).replace(/\//g, "-").replace(/\s/g, "-").replace(/-+/g, "-").replace(/\./g, "").replace(/^-/, "").replace(/-$/, "").toLowerCase();
}

function getRomanNames(productName, brandName, languageCode) {
  var romanProductName = productName;
  var romanBrandName = brandName;

  if (languageCode && languageCode.toLowerCase() === "ru-ru") {
    romanProductName = convertCyrillicToRoman(productName);
    romanBrandName = convertCyrillicToRoman(brandName);
  }

  return {
    romanProductName: romanProductName,
    romanBrandName: romanBrandName
  };
}

function createSeoPath(logger) {
  return function (productName, brandName, languageCode) {
    if (typeof "".normalize !== "function") {
      return "";
    }

    if (!productName) {
      if (logger) {
        logger.error("createSeoPath - productName was not passed in");
      }

      return "";
    }

    var _getRomanNames = getRomanNames(productName, brandName, languageCode),
        romanProductName = _getRomanNames.romanProductName,
        romanBrandName = _getRomanNames.romanBrandName;

    var sanitisedProductName = sanitiseName(romanProductName);
    var sanitisedBrandName = sanitiseName(romanBrandName);
    return "".concat(sanitisedBrandName, "/").concat(sanitisedProductName);
  };
}

module.exports = createSeoPath;
